import axios from 'axios';
import router from '../router';
import urls from '../utils/config';
console.log('urls: ', urls)

//创建axios的一个实例
const instance = axios.create({
  // baseURL: '/api',
  baseURL: process.env.NODE_ENV == 'development' ? process.env.VUE_APP_BASEURL: urls['baseUrl'],
  timeout: 5000
});

//添加请求头
// instance.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8;';
// instance.defaults.headers.common = {
//   'Access-Control-Allow-Origin': '*',
//   'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
//   'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
// };

//------------------- 一、请求拦截器 后面介绍
instance.interceptors.request.use(function (config) {
// 登录相关
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


// http response 拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.data.code == -20418) {
      // storage.remove('user');
      router.push({
        path: '/login',
        querry: { redirect: router.currentRoute.fullPath }, // 从哪个页面跳转
      });
    }
    return response;
  },
  error => Promise.reject(error),
);

//----------------- 二、响应拦截器 后面介绍
instance.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {String} url     请求的url:
 * @param {Object} data    请求的参数
 * @returns {Promise<AxiosResponse<T>>}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */
export default function (method, url, data = null, config = {}) {
  method = method.toLowerCase();
  if (method == 'post') {
    return instance.post(url, data, config);
  } else if (method == 'get') {
    return instance.get(url, { params: data }, config);
  } else if (method == 'delete') {
    return instance.delete(url, { params: data }, config);
  } else if (method == 'put') {
    return instance.put(url, data, config);
  } else {
    console.error('未知的method' + method);
    return false;
  }
}
